<template>
  <v-card>
    <v-card-title>
      Device Alerts
      (List the most recent {{ items.length }} alerts. Latest record at the top)
      <v-btn small icon @click="dataRefresh">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search">
      </v-text-field>
    </v-card-title>
    <v-progress-linear
      :indeterminate="true"
      :active="showProgress">
    </v-progress-linear>
    <v-data-table
      v-bind:headers="headers"
      v-bind:items="items"
      v-bind:search="search"
      v-bind:rows-per-page-items="rowsPerPage"
      :disable-initial-sort="true">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.serial }}</td>
        <td class="text-xs-left">{{ showLogType(props.item.logType) }}</td>
        <td class="text-xs-left">{{ showAlertValue(props.item.alertValue) }}</td>
        <td class="text-xs-left">{{ showAlertStatus(props.item.alertStatus) }}</td>
        <td class="text-xs-left">{{ unixtimeAt(props.item.deviceTimestamp) }}</td>
        <td class="text-xs-left">{{ localAt(props.item.createdAt) }}</td>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
    <div class="red white--text subheading">{{ errMsg }}</div>
  </v-card>
</template>

<script>
  import mixins from '@/mixins.js'
  import CareUserService from '@/services/CareUserService'
  import DeviceAlertService from '@/services/DeviceAlertService'
  import moment from 'moment'

  export default {
    data() {
      return {
        errMsg: '',
        showProgress: true,
        tmp: '',
        search: '',
        selected: [],
        pagination: {},
        rowsPerPage: [
          10,
          20,
          {"text": "All", "value": -1}
        ],
        headers: [
          { text: 'Device Serial', align: 'left', value: 'serial' },
          { text: 'Alert Type', align: 'left', value: 'logType' },
          { text: 'Value', align: 'left', value: 'alertValue' },
          { text: 'Status', align: 'left', value: 'alertStatus' },
          { text: 'Device Timestamp (local time)', align: 'left', value: 'deviceTimeStamp' },
          { text: 'Database Timestamp (local time)', align: 'left', value: 'createdAt' },
        ],
        items: []
      }
    },
    mixins: [mixins],
    async mounted() {
      try {
        this.errMsg = ''
        this.items = []
        this.showProgress = true
        const careUserId = this.$route.params.id
        var careUser = (await CareUserService.show({careUserId})).data
        if (careUser) {
          if (careUser.devices) {
            if (careUser.devices.length > 1) {
              var deviceIds = []
              var result_items = []
              var deviceSerials = []
              for (var i = 0; i < careUser.devices.length; i++) {
                deviceIds.push(careUser.devices[i].deviceId)
              }
              if (deviceIds) {
                var sub_items = (await DeviceAlertService.showCareUserAlerts({deviceIds: deviceIds})).data
                if (sub_items) {
                  for (var j = 0; j < sub_items.length; j++) {
                    for (var k = 0; k < careUser.devices.length; k++) {
                      if (sub_items[j].deviceId === careUser.devices[k].deviceId) {
                        this.$set(sub_items[j], 'serial', careUser.devices[k].serial)
                        break
                      }
                    }
                  }
                  this.items.push.apply(this.items,sub_items)
                }
              }
            } else {
              var serial = careUser.devices[0].serial
              var sub_items = (await DeviceAlertService.showAll({deviceId: careUser.devices[0].deviceId})).data
              if (sub_items) {
                for (var j = 0; j < sub_items.length; j++) {
                  this.$set(sub_items[j], 'serial', serial)
                }
                this.items.push.apply(this.items,sub_items)
              }
            }
          }
        }
        this.showProgress = false
      } catch (error) {
        this.showProgress = false
        this.errMsg = this.handleError(error)
      }
    },
    methods: {
      localAt: function(time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss.SSS A")
      },
      unixtimeAt: function(time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss.SSS A")
      },
      compare: function(a, b) {
        let comparison = 0
        if (a.createdAt > b.createdAt) {
          comparison = -1
        } else if (b.createdAt > a.createdAt) {
          comparison = 1
        }
        return b.createdAt - a.createdAt
      },
      showAlertValue: function(alertValue) {
        if (alertValue) {
          if (alertValue == 8888888.0000) {
            return 'DETECTED (8888888.0000)'
          } else {
            return alertValue
          }
        } else {
          return alertValue
        }
      },
      showAlertStatus: function(alertStatus) {
          if (alertStatus === 0) {
            return 'Not Acknowledged (Status 0)'
          } else if (alertStatus === 1) {
            return 'Acknowledged from screen (Status 1)'
          } else {
            return 'Unknown (Status ' + alertStatus + ')'
          }
      },
      showLogType: function(logType) {
        if (logType) {
          if (logType === 9011) {
            return 'Distress Call (9011)'
          } else if (logType === 9021) {
            return 'Low Heart Rate (9021)'
          } else if (logType === 9022) {
            return 'High Heart Rate (9022)'
          } else if (logType === 9031) {
            return 'High Rotation (9031)'
          } else if (logType === 9032) {
            return 'High Acceleration (9032)'
          } else if (logType === 9033) {
            return 'High Gravity (9033)'
          } else if (logType === 9034) {
            return 'Low Gravity (9034)'
          } else if (logType === 9039) {
            return 'Fall (9039)'
          } else {
            return 'Unknown Type (' + logType + ')'
          }
        } else {
          return 'Unknown Type'
        }
      },
      async dataRefresh() {
        try {
          this.errMsg = ''
          this.showProgress = true
          this.items = []
          this.showProgress = true
          const careUserId = this.$route.params.id
          var careUser = (await CareUserService.show({careUserId})).data
          if (careUser) {
            if (careUser.devices) {
              if (careUser.devices.length > 1) {
                var deviceIds = []
                var result_items = []
                var deviceSerials = []
                for (var i = 0; i < careUser.devices.length; i++) {
                  deviceIds.push(careUser.devices[i].deviceId)
                }
                if (deviceIds) {
                  var sub_items = (await DeviceAlertService.showCareUserAlerts({deviceIds: deviceIds})).data
                  if (sub_items) {
                    for (var j = 0; j < sub_items.length; j++) {
                      for (var k = 0; k < careUser.devices.length; k++) {
                        if (sub_items[j].deviceId === careUser.devices[k].deviceId) {
                          this.$set(sub_items[j], 'serial', careUser.devices[k].serial)
                          break
                       }
                      }
                    }
                    this.items.push.apply(this.items,sub_items)
                  }
                }
              } else {
                var serial = careUser.devices[0].serial
                var sub_items = (await DeviceAlertService.showAll({deviceId: careUser.devices[0].deviceId})).data
                if (sub_items) {
                  for (var j = 0; j < sub_items.length; j++) {
                    this.$set(sub_items[j], 'serial', serial)
                  }
                  this.items.push.apply(this.items,sub_items)
                }
              }
            }
          }
          this.showProgress = false
        } catch (error) {
          this.showProgress = false
          this.errMsg = this.handleError(error)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CareUser/CareUserTabAlertHistory.vue